import { DEFAULT_FEATURES, type FeatureEntry, type Team } from "./features";

export type TeamSource = "feature" | "triage" | "default";

// A Feature on the list decides the team. With no Feature, or "Other", the team triage suggested is used; failing that, Platform.
export function routeTeam(
  feature: string | undefined,
  triageTeam: Team | null | undefined,
  features: readonly FeatureEntry[] = DEFAULT_FEATURES,
): { team: Team; source: TeamSource } {
  const mapped = feature && feature !== "Other" ? features.find((entry) => entry.label === feature)?.team : undefined;
  if (mapped) {
    return { team: mapped, source: "feature" };
  }
  if (triageTeam) {
    return { team: triageTeam, source: "triage" };
  }
  return { team: "Platform", source: "default" };
}
